<template>
    <div>
        <el-dialog title="上传资质资料(如果失败根据提示重新上传)" width="1100px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" ref="form" :model="form" :inline="true">
                <el-form-item label="真实姓名" prop="entity_name">
                    <el-input v-model="form.entity_name" autoComplete="off" clearable placeholder="请输入讲师名称"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="id_number">
                    <el-input v-model="form.id_number" autoComplete="off" clearable placeholder="请输入身份证号"></el-input>
                </el-form-item>
            </el-form>
            <el-form :size="size" ref="form" :model="form" :rules="rules">
                <el-row>
                    <el-form-item label="讲师头像">
                        <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers" :data="updataimg"
                            accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP" :show-file-list="false"
                            :on-success="handleicon" :before-upload="handleicons">
                            <el-image v-if="form.icon" class="avatarheader" :src="form.icon" ></el-image>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-row>
                <div style="display: flex;justify-content: space-between;">
                    <div style="width: 70%;">
                        <div style="display: flex;" >
                            <div style="width: 50%;">
                                <div>
                                    身份证正面图人像面
                                </div>
                                <el-form-item label="身份证号到期时间">
                                    <el-date-picker type="date" placeholder="选择日期" v-model="form.expire_time"
                                        style="width: 50%;" format="yyyy 年 MM 月 dd 日"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                                <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers"
                                    :data="updataimg"
                                    accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">
                                    <el-image v-if="form.front_img" class="avatarsf" :src="form.front_img"></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon-sf"></i>
                                </el-upload>
                            </div>
                            <div style="margin-top: 50px;">
                                <div>
                                    身份证反面图国徽面
                                </div>
                                <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers"
                                    :data="updataimg"
                                    accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                    :show-file-list="false" :on-success="handleAvatarSuccess1"
                                    :before-upload="beforeAvatarUpload1">
                                    <el-image v-if="form.back_img" class="avatarsf" :src="form.back_img"></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon-sf"></i>
                                </el-upload>
                            </div>
                        </div>

                        <div style="display: flex;margin-top: 20px;">
                            <div style="width: 50%;">
                                <div style="color: red;">
                                    *机动车驾驶证实物满分驾照或电子版驾照截图
                                </div>
                                <el-form-item label="电子版驾照到期时间">
                                    <el-date-picker type="date" placeholder="选择日期" v-model="form.material_expiretime"
                                        style="width: 50%;" format="yyyy 年 MM 月 dd 日"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                                <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers"
                                    :data="updataimg"
                                    accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                    :show-file-list="false" :on-success="handleAvatarSuccess2"
                                    :before-upload="beforeAvatarUpload2">
                                    <el-image v-if="form.material_img" class="avatar1" :src="form.material_img"></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                                </el-upload>
                            </div>

                            <div style="width: 50%;">

                                <div style="color: red;">
                                    *教师安全驾驶记录证明截图：交管12123查询
                                </div>
                                <el-form-item label="驾驶记录证明到期时间">
                                    <el-date-picker type="date" placeholder="选择日期" v-model="form.material_expiretime2"
                                        style="width: 50%;" format="yyyy 年 MM 月 dd 日"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                                <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers"
                                    :data="updataimg"
                                    accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                    :show-file-list="false" :on-success="handleAvatarSuccess3"
                                    :before-upload="beforeAvatarUpload3">
                                    <el-image v-if="form.material_img2" class="avatar1" :src="form.material_img2"></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <div style="width: 30%;">
                        <div style="color: red;">
                                    *授权函
                                </div>
                                <el-form-item label="授权函到期时间">
                                    <el-date-picker type="date" placeholder="选择日期" v-model="form.letters_time"
                                        style="width: 80%;" format="yyyy 年 MM 月 dd 日"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                                </el-form-item>
                                <el-upload class="avatar-uploader" :action="updatehttp" :headers="headers"
                                    :data="updataimg"
                                    accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                    :show-file-list="false" :on-success="handleAvatarSuccess4"
                                    :before-upload="beforeAvatarUpload4">
                                    <el-image v-if="form.letters_img" class="avatar3" :src="form.letters_img"></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon3"></i>
                                </el-upload>
                    </div>


                </div>


            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading" type="primary" @click="submit">
                    <span v-if="!loading">确 定</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getUpResources } from '../../api/userMG';
import axios from 'axios';
export default {
    name: 'Add',
    components: {
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object,
        },
        lids:{
            type: Number,
        }
    },
    data() {
        return {
            updatehttp: '/lecturer/putFile',
            headers: {
                token: localStorage.getItem('logintoken')
            },
            form: {
                lid: '',
                entity_name: '', //真实姓名
                id_number: '',//身份证号
                expire_time: '',//身份证到期时间
                front_img: '', //身份证正面图人像面
                front_path: '', //身份证正面链接
                back_img: '',//身份证反面图国徽面
                back_path: '',//
                material_img: '',//	资质材料图
                material_paths: '', //资质材料链接
                material_expiretime: '',//资料过期时间
                material_img2: '',//	资质材料图
                material_paths2: '', //资质材料链接
                material_expiretime2: '',//资料过期时间
                letters_img: '',
                letters_auths: '',
                letters_time: '',
                icon: '', //头像
                icon_paths: '' //头像链接
            },
            loading: false,
            rules: {},
            updataimg: {
                file_name: ''
            },
            lid:''
        }
    },
    created() {
        this.userinfo = JSON.parse(localStorage.getItem('userdata'))
        console.log(this.userinfo.Permissions_type);
    },
    methods: {
        //头像上传
        handleicon(res, file) {
            this.form.icon = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            console.log(this.form.icon);
            this.form.icon_paths = res.path
        },
        handleicons(file) {
            this.updataimg.file_name = 'icon_img' + '_' + this.form.lid
        },
        //身份证
        handleAvatarSuccess(res, file) {
            this.form.front_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            this.form.front_path = res.path
        },
        beforeAvatarUpload(file) {
            this.updataimg.file_name = 'front_img' + '_' + this.form.lid
        },
        handleAvatarSuccess1(res, file) {
            this.form.back_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            this.form.back_path = res.path
        },
        beforeAvatarUpload1(file) {
            this.updataimg.file_name = 'back_img' + '_' + this.form.lid
        },
        //资质材料
        handleAvatarSuccess2(res, file) {
            this.form.material_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            this.form.material_paths = res.path
        },
        beforeAvatarUpload2(file) {
            this.updataimg.file_name = 'material_img' + '_' + this.form.lid
        },
        handleAvatarSuccess3(res, file) {
            this.form.material_img2 = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            this.form.material_paths2 = res.path
        },
        beforeAvatarUpload3(file) {
            this.updataimg.file_name = 'material_img2' + '_' + this.form.lid
        },
        handleAvatarSuccess4(res, file) {
            this.form.letters_img = res.img_url.substring(0,res.img_url.lastIndexOf("?"));
            this.form.letters_auths = res.path
        },
        beforeAvatarUpload4(file) {
            this.updataimg.file_name = 'letters_img' + '_' + this.form.lid
        },
        open() {
            console.log(this.info);
            console.log(this.lids);
            console.log('111111111111111');
            if(this.info == null){
                this.form.lid =  this.lids
                console.log('执行添加');
            }else{
                console.log('执行修改');
                this.form = this.info
                this.lid = this.form.lid
            }
        },
        submit() {
            // this.form.lid = this.lid
            console.log(this.form);
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    this.form.echo = 'set'
                    getUpResources(this.form).then(res => {
                        console.log(res.code);
                        if (res.code == 200) {
                            this.$message({ message: '操作成功', type: 'success' })
                            this.$emit('refesh_list')
                            this.closeForm()
                        } else {
                            this.$message({ message: res.msg, type: 'error' })
                            this.loading = false
                        }
                    }).catch(() => {
                        // this.loading = false
                    })
                }
            })
        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            this.form = {}
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.editor {
    height: 200px;
}

.flexs {
    display: flex;
    justify-content: space-between;
    width: 600px;
    margin-bottom: 10px;
}

.flexs-l {}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    border: 1px solid #dadcdf;
    border-radius: 10px;
}

.avatarheader {
    width: 100px;
    height: 100px;
    display: block;
    border: 1px solid #dadcdf;
}

.avatar-uploader-icon-sf {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 160px;
    line-height: 160px;
    text-align: center;
    border: 1px solid #dadcdf;
    border-radius: 10px;
}

.avatarsf {
    width: 300px;
    height: 160px;
    display: block;
    border: 1px solid #dadcdf;
}
.avatar-uploader-icon1 {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 300px;
    line-height: 300px;
    text-align: center;
    border: 1px solid #dadcdf;
    border-radius: 10px;
}

.avatar1 {
    width: 300px;
    height: 300px;
    display: block;
    border: 1px solid #dadcdf;
}
.avatar-uploader-icon3 {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 550px;
    line-height: 550px;
    text-align: center;
    border: 1px solid #dadcdf;
    border-radius: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/lecturer/updateimg.vue